import classnames from 'classnames';
import React from 'react';
import { noop } from '../helpers';
import { DefaultFieldRenderer } from '../field-renderers';
import { FieldProps, FieldFactoryProps } from '../types';
import '../../styles/switch-field.scss';
import classNames from 'classnames';

interface Props extends FieldProps<boolean, HTMLInputElement>, ExtraProps {}
interface FFProps extends FieldFactoryProps<boolean, HTMLInputElement>, ExtraProps {}

interface ExtraProps {
  valueLabelOn?: string;
  valueLabelOff?: string;
}

const SwitchField = (props: Props) => {
  const { value, className = '', Renderer = DefaultFieldRenderer } = props;
  const cls = classnames(`${className}`, 'switch-field', value ? 'switch-field-on' : 'switch-field-off');
  return <Renderer className={cls} {...props} factory={factory} />;
};

const factory = ({
  name = null,
  value = false,
  onValueChange = noop,
  valueLabelOff = 'Off',
  valueLabelOn = 'On',
  className,
  ...props
}: FFProps) => (
  <label className="switch-field-label">
    <input
      type="checkbox"
      name={name}
      checked={value}
      onChange={(e) => {
        onValueChange(e.currentTarget.checked, value, name, e);
      }}
      className={classNames(className)}
      {...props}
    />
    {valueLabelOn && value && valueLabelOn}
    {valueLabelOff && !value && valueLabelOff}
  </label>
);

export default SwitchField;
